const conditions = () => {
  return [{ assetClass: { $ne: '' } }, { projectType: { $ne: '' } }, { investmentVolume: { portfolioSearch: 'my-objects.pipeline.assets-class.investment-volume.portfolio.yes' } }]
}

export default conditions
